import { cn } from '@/lib/utils';
import { Tooltip } from '@/libs/components/src/lib/Tooltip';
import Dropdown from '../../../../common/Dropdown';

type Props = {
  dropdownOptions: string[];
  value: { choice: string; explanation?: string };
  onChange: (val: string) => void;
  defaultVal: string | string[];
  row: string;
};

const NeuroDropdown: React.FC<Props> = ({ dropdownOptions, value, onChange, defaultVal, row }) => {
  const isNotAssessed = value?.choice === 'Not assessed' || !value?.choice;

  return (
    <Dropdown
      className="w-full"
      options={dropdownOptions.map(item => {
        return {
          text: item,
          onClick: () => onChange(item),
        };
      })}
      buttonClassName={cn('w-full', isNotAssessed ? 'min-w-28 hover:bg-gray-50/80' : '')}
      clickableElement={
        <div
          className={[
            value?.choice === defaultVal ? 'text-primary-600' : 'text-red-500',
            'w-full text-center',
          ].join(' ')}
        >
          {isNotAssessed ? (
            <>&nbsp;</>
          ) : (
            <>
              {value?.choice}{' '}
              {value?.explanation && value?.choice === 'Abnormal' && (
                <span className="flex justify-center ml-28 -mt-6">
                  <Tooltip content={value?.explanation}>
                    <svg
                      className="shrink-0 mr-1.5 h-5 w-5 text-gray-400 hover:text-gray-500"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      id={row}
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </Tooltip>
                </span>
              )}
            </>
          )}
        </div>
      }
    />
  );
};

export default NeuroDropdown;
